<template>
	<div class="offer-stat-tile">
		<div class="offer-stat-tile__icon">
			<slot name="icon"></slot>
		</div>
		<div class="offer-stat-tile__label">
			<slot name="title"></slot>
		</div>
	</div>
</template>



<style scoped lang="scss">
@use "@/assets/scss/utilities/background" as *;

.offer-stat-tile {
	@extend .background-tile-secondary;
	border-top: vars.get-map-value(vars.$border, tile-secondary);
	height: 120px;
	padding: 16px;
	border-radius: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	&__icon {
		font-size: 32px;
		font-weight: 600;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__label {
		color: vars.get-map-value(vars.$text-color, subtitle);
		font-size: 14px;
		font-weight: 500;
	}
}
</style>
